import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { FallbackView } from "../../_start/partials";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { ProjectDetailsPageWrapper } from "../pages/dashboards/project-dashboard/ProjectDetailsPageWrapper";
import { ProjectDashboardWrapper } from "../pages/dashboards/project-dashboard/ProjectDashboardWrapper";
import { StartDashboardWrapper } from "../pages/dashboards/start-dashboard/StartDashboardWrapper";
import { BrandingSetupPageWrapper } from "../pages/dashboards/project-dashboard/BrandingSetupPageWrapper";
import { LaunchDashboardWrapper } from "../pages/dashboards/launch-dashboard/LaunchDashboardWrapper";
import { AdminDashboardWrapper } from "../pages/dashboards/admin-dashboard/AdminDashboardWrapper";
import {
  GenericStep1Wrapper,
  GenericStep2Wrapper,
  GenericStep3Wrapper,
  GenericStep4Wrapper,
  GenericStep5Wrapper,
  GenericStep6Wrapper,
  GenericStep7Wrapper,
  GenericStep8Wrapper,
  GenericStep9Wrapper,
  GenericStep10Wrapper,
  GenericStep11Wrapper,
  GenericStep12Wrapper,
  GenericStep13Wrapper,
  GenericStep14Wrapper,
  GenericStep15Wrapper,
  GenericStep16Wrapper,
  GenericStep17Wrapper,
  GenericStep18Wrapper,
  GenericStep19Wrapper,
  GenericStep20Wrapper,
  GenericStep21Wrapper,
  GenericStep22Wrapper,
  GenericStep23Wrapper,
  GenericStep24Wrapper,
} from "../pages/dashboards/steps/GenericStepWrapper";
import { AIProgressPage } from "../pages/dashboards/ai-progress/AIProgressPage";
import { AIReviewPage } from "../pages/dashboards/ai-review/AIReviewPage";
import { MenuTestPage } from "../pages/MenuTestPage";

// Lazy-loaded components
const TeamPageWrapper = lazy(
  () => import("../pages/team/TeamPageWrapper").then((m) => ({ default: m.TeamPageWrapper }))
);
const BuilderPageWrapper = lazy(
  () => import("../pages/layout-builder/BuilderPageWrapper")
);
const ProfilePageWrapper = lazy(
  () => import("../modules/profile/ProfilePageWrapper")
);
const ChatPageWrapper = lazy(
  () => import("../modules/apps/chat/ChatPageWrapper")
);
const ShopPageWrapper = lazy(
  () => import("../modules/apps/shop/ShopPageWrapper")
);
const GeneralPageWrapper = lazy(
  () => import("../modules/general/GeneralPageWrapper")
);
const DocsPageWrapper = lazy(
  () => import("../modules/docs/DocsPageWrapper")
);
const HelpPageWrapper = lazy(
  () => import("../modules/help/HelpPageWrapper")
);

export function PrivateRoutes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<FallbackView />}>
        <Routes>
          <Route path="/dashboard" element={<StartDashboardWrapper />} />
          <Route path="/project" element={<ProjectDashboardWrapper />} />
          <Route path="/project-details" element={<ProjectDetailsPageWrapper />} />
          <Route path="/branding-setup" element={<BrandingSetupPageWrapper />} />
          <Route path="/launch-dashboard" element={<LaunchDashboardWrapper />} />
          <Route path="/admin" element={<AdminDashboardWrapper />} />
          <Route path="/team" element={<TeamPageWrapper />} />
          <Route path="/step1" element={<GenericStep1Wrapper />} />
          <Route path="/step2" element={<GenericStep2Wrapper />} />
          <Route path="/step3" element={<GenericStep3Wrapper />} />
          <Route path="/step4" element={<GenericStep4Wrapper />} />
          <Route path="/step5" element={<GenericStep5Wrapper />} />
          <Route path="/step6" element={<GenericStep6Wrapper />} />
          <Route path="/step7" element={<GenericStep7Wrapper />} />
          <Route path="/step8" element={<GenericStep8Wrapper />} />
          <Route path="/step9" element={<GenericStep9Wrapper />} />
          <Route path="/step10" element={<GenericStep10Wrapper />} />
          <Route path="/step11" element={<GenericStep11Wrapper />} />
          <Route path="/step12" element={<GenericStep12Wrapper />} />
          <Route path="/step13" element={<GenericStep13Wrapper />} />
          <Route path="/step14" element={<GenericStep14Wrapper />} />
          <Route path="/step15" element={<GenericStep15Wrapper />} />
          <Route path="/step16" element={<GenericStep16Wrapper />} />
          <Route path="/step17" element={<GenericStep17Wrapper />} />
          <Route path="/step18" element={<GenericStep18Wrapper />} />
          <Route path="/step19" element={<GenericStep19Wrapper />} />
          <Route path="/step20" element={<GenericStep20Wrapper />} />
          <Route path="/step21" element={<GenericStep21Wrapper />} />
          <Route path="/step22" element={<GenericStep22Wrapper />} />
          <Route path="/step23" element={<GenericStep23Wrapper />} />
          <Route path="/step24" element={<GenericStep24Wrapper />} />
          <Route path="/ai-progress" element={<AIProgressPage />} />
          <Route path="/ai-review" element={<AIReviewPage />} />
          <Route path="/builder" element={<BuilderPageWrapper />} />
          <Route path="/general/*" element={<GeneralPageWrapper />} />
          <Route path="/chat/*" element={<ChatPageWrapper />} />
          <Route path="/shop/*" element={<ShopPageWrapper />} />
          <Route path="/profile/*" element={<ProfilePageWrapper />} />
          <Route path="/menu-test" element={<MenuTestPage />} />
          <Route path="/docs/*" element={<DocsPageWrapper />} />
          <Route path="/help/*" element={<HelpPageWrapper />} />
          <Route path="/auth/*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/error/404" replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
